import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchMenuItems,
  createMenuItem,
  updateMenuItem,
  updateMenuItemImage,
  deleteMenuItem,
} from "./slices/MenuItemsSlice";
import "./MenuItems.css";
import FeaturedItems from "./FeaturedItems";

function MenuItems() {
  const dispatch = useDispatch();
  const { menuItems, loading, error } = useSelector((state) => state.menuItems);

  const [isMenuVisible, setIsMenuVisible] = useState(true);
  const [editableItems, setEditableItems] = useState([]);

  const [newItem, setNewItem] = useState({
    name: "",
    description: "",
    price: "",
    imageFile: null,
    isFeatured: false,
    category: "Dinner",
  });

  useEffect(() => {
    dispatch(fetchMenuItems());
  }, [dispatch]);

  useEffect(() => {
    const sanitized = menuItems.map((item) => ({
      ...item,
      price: item.price?.toString().replace(/[^0-9.]/g, ""), // strip any $ or extra chars
    }));
    setEditableItems(sanitized);
  }, [menuItems]);


  const handleInputChange = (e, index, field) => {
    let value = e.target.value;

    if (field === "price") {
      console.log(field, "field")
      value = value.replace(/[^0-9.]/g, ""); // removes $ and non-numeric characters
      const decimalIndex = value.indexOf(".");
      if (decimalIndex !== -1) {
        value = value.slice(0, decimalIndex + 3); // keep 2 decimal places
      }
    }

    const updatedItems = [...editableItems];
    updatedItems[index] = { ...updatedItems[index], [field]: value };
    setEditableItems(updatedItems);
  };


  const handleFileChange = (e, index) => {
    const file = e.target.files[0];
    const updatedItems = [...editableItems];
    updatedItems[index] = { ...updatedItems[index], imageFile: file };
    setEditableItems(updatedItems);
  };

  const handleUpdateClick = async (item, index) => {
    const { posId, imageFile, ...updatableFields } = item;

    try {
      const res = await dispatch(updateMenuItem({ itemId: item.posId, updatedData: updatableFields }));

      if (!res.error) {
        let updatedData = { ...item, ...res.payload };

        if (imageFile) {
          const imageRes = await dispatch(updateMenuItemImage({ itemId: item.posId, file: imageFile }));

          if (!imageRes.error && imageRes.payload?.imageUrl) {
            updatedData.imageUrl = imageRes.payload.imageUrl;
            updatedData.imageFile = null;
          } else {
            console.warn("⚠️ Image updated but no URL returned from backend.", imageRes.payload);
          }
        }

        const updatedItems = [...editableItems];
        updatedItems[index] = updatedData;
        setEditableItems(updatedItems);
        console.log("✅ Updated editableItems:", updatedItems);
        dispatch(fetchMenuItems());

      } else {
        console.error("❌ Failed to update item:", res.error);
      }
    } catch (err) {
      console.error("❌ Unexpected error in handleUpdateClick:", err);
    }
  };




  const handleRemoveItem = async (id) => {
    console.log("bbb", id)
    if (!id) return;
    await dispatch(deleteMenuItem(id));
    dispatch(fetchMenuItems());
  };

  const handleAddNewItem = async () => {
    if (!newItem.name || !newItem.price || !newItem.description || !newItem.imageFile) {
      alert("All fields and an image are required.");
      return;
    }

    const formData = new FormData();
    formData.append("name", newItem.name);
    formData.append("description", newItem.description);
    formData.append("price", newItem.price);
    formData.append("category", newItem.category);
    formData.append("isFeatured", newItem.isFeatured);
    formData.append("file", newItem.imageFile);

    await dispatch(createMenuItem(formData));
    dispatch(fetchMenuItems());

    setNewItem({
      name: "",
      description: "",
      price: "",
      imageFile: null,
      isFeatured: false,
      category: "Dinner",
    });
  };

  const handleNewItemChange = (e, field) => {
    setNewItem({ ...newItem, [field]: e.target.value });
  };
  const featuredItems = menuItems.filter(item => item.isFeatured).slice(0, 4);
  console.log(menuItems[1])
  console.log(featuredItems, "bob featured items")
  return (
    <div className="menu-items-container">
      <div className="featured-section-wrapper">
        <FeaturedItems featuredItems={featuredItems} />
      </div>



      <div className="menu-items-sections">
        <h2>Menu</h2>

        <label>
          Show Menu:
          <input
            type="checkbox"
            checked={isMenuVisible}
            onChange={() => setIsMenuVisible(!isMenuVisible)}
          />
        </label>
        {loading && <p>Loading menu items...</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}

        {isMenuVisible && (
          <>
            <div className="menu-items">
              {editableItems.map((item, index) => (
                <div key={item._id} className="menu-item">
                  <div className="menu-item-info">
                    <h3>{item.name}</h3>
                    <div className="image-preview">
                      <img src={item.imageUrl} alt={item.name} />
                    </div>
                    <label>
                      Description:
                      <input
                        value={item.description}
                        onChange={(e) => handleInputChange(e, index, "description")}
                        placeholder="Enter description"
                      />
                    </label>
                    <label>
                      Name:
                      <input
                        value={item.name}
                        onChange={(e) => handleInputChange(e, index, "name")}
                        placeholder="Enter item name"
                      />
                    </label>
                    <label>
                      Price:
                      <div className="price-input-wrapper">
                        <span className="dollar-sign">$</span>
                        <input
                          value={item.price}
                          onChange={(e) => handleInputChange(e, index, "price")}
                          placeholder="0.00"
                        />
                      </div>
                    </label>
                    <label>
                      Featured:
                      <input
                        type="checkbox"
                        checked={item.isFeatured}
                        onChange={(e) => {
                          const updated = [...editableItems];
                          const isChecking = e.target.checked;

                          // Count current featured (excluding this item if it's already featured)
                          const featuredCount = updated.filter((i, idx) => i.isFeatured && idx !== index).length;

                          if (isChecking && featuredCount >= 4) {
                            alert("You can only select up to 4 featured items.");
                            return;
                          }

                          updated[index].isFeatured = isChecking;
                          setEditableItems(updated);
                        }}
                      />
                    </label>




                    <input
                      type="file"
                      onChange={(e) => handleFileChange(e, index)}
                      accept="image/*"
                    />
                    <div>
                      <label>Category:</label>
                      <select
                        value={item.category}
                        onChange={(e) => handleInputChange(e, index, "category")}
                      >
                        <option value="Dinner">Dinner</option>
                        <option value="Beverages">Beverages</option>
                        <option value="Appetizers">Appetizers</option>
                        <option value="Lunch">Lunch</option>
                      </select>
                    </div>
                    <button className="update-btn" onClick={() => handleUpdateClick(item, index)}>Edit</button>
                    <button className="remove-btn" onClick={() => handleRemoveItem(item.posId)}>Remove</button>
                  </div>
                </div>
              ))}
            </div>

            <div className="new-item">
              <h3>Add New Menu Item</h3>
              <label>
                Name:
                <input
                  className="name-input"
                  // type="text"
                  value={newItem.name}
                  onChange={(e) => handleNewItemChange(e, "name")}
                  placeholder="Enter item name"
                />
              </label>

              <label>
                Description:
                <textarea
                  value={newItem.description}
                  onChange={(e) => handleNewItemChange(e, "description")}
                  placeholder="Enter description"
                />
              </label>

              <label>
                Price:
                <div className="price-input-wrapper">
                  <span className="dollar-sign">$</span>
                  <input
                    // type="text"
                    value={newItem.price}
                    onChange={(e) => handleNewItemChange(e, "price")}
                    placeholder="0.00"
                  />
                </div>
              </label>


              <div className="image-upload">
                <label>Upload Image</label>
                <input
                  type="file"
                  onChange={(e) =>
                    setNewItem({ ...newItem, imageFile: e.target.files[0] })
                  }
                  accept="image/*"
                />
                {newItem.imageFile && (
                  <img
                    src={URL.createObjectURL(newItem.imageFile)}
                    alt="Preview"
                    style={{ width: "100px", marginTop: "10px" }}
                  />
                )}
              </div>
              <label>
                Featured:
                <input
                  type="checkbox"
                  checked={newItem.isFeatured}
                  onChange={(e) =>
                    setNewItem({ ...newItem, isFeatured: e.target.checked })
                  }
                />
              </label>

              <div>
                <label>Category:</label>
                <select
                  value={newItem.category}
                  onChange={(e) => handleNewItemChange(e, "category")}
                >
                  <option value="Dinner">Dinner</option>
                  <option value="Beverages">Beverages</option>
                  <option value="Appetizers">Appetizers</option>
                  <option value="Lunch">Lunch</option>

                </select>
              </div>
              <button type="button" onClick={handleAddNewItem}>
                Add Item
              </button>
            </div>
          </>
        )}
      </div>

    </div>
  );
}

export default MenuItems;
